var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InvestmentTransactionProvider',{attrs:{"portfolio-id":_vm.portfolio,"module":_vm.getModule}},[_c(_vm.transactionComponent,{tag:"component",attrs:{"portfolio":_vm.portfolio}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }